angular
    .module("skillBuilderSaaS")
    .filter("sumByField", function () {
    return function (collection, column) {
        var total = 0;
        collection.forEach(function (item) {
            total += parseFloat(item[column]);
        });
        return total;
    };
});
